var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTrainerIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.25,
    height: 13,
    viewBox: "0 0 16.25 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-shield",
    "data-name": "Icon awesome-user-shield",
    d: "M15.8,6.883,12.876,5.741a.787.787,0,0,0-.564,0L9.387,6.883a.687.687,0,0,0-.449.632,5.772,5.772,0,0,0,3.374,5.431.788.788,0,0,0,.564,0A5.753,5.753,0,0,0,16.25,7.516.687.687,0,0,0,15.8,6.883Zm-3.207,4.857v-4.8l2.425.947A4.542,4.542,0,0,1,12.594,11.741ZM5.688,6.5a3.25,3.25,0,1,0-3.25-3.25A3.25,3.25,0,0,0,5.688,6.5ZM8.125,7.516a1.442,1.442,0,0,1,.028-.183c-.063,0-.124-.02-.19-.02H7.538a4.42,4.42,0,0,1-3.7,0H3.412A3.413,3.413,0,0,0,0,10.725v1.056A1.219,1.219,0,0,0,1.219,13h8.938a1.25,1.25,0,0,0,.488-.1A6.822,6.822,0,0,1,8.125,7.516Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTrainerIco);
export default __webpack_public_path__ + "static/media/new-trainer-ico.b27deb77.svg";
export { ForwardRef as ReactComponent };